<template>
  <div class="EmergencyOverview">
    <div class="EmergencyOverview-row">
      <div class="EmergencyOverview-row__column">
        <img src="~@src/common/assets/images/screen/emergencyPlan.png" />
        <div class="column-info">
          <div class="column-info__title">应急预案数</div>
          <div class="column-info__content">
            <div class="content-value">{{ info.emergencyCount }}</div>
            <div class="content-unit">个</div>
          </div>
        </div>
      </div>
      <div class="EmergencyOverview-row__column emergency-people" @click="chartClick('060303')">
        <img src="~@src/common/assets/images/screen/emergency.png" />
        <div class="column-info">
          <div class="column-info__title">应急人员数</div>
          <div class="column-info__content">
            <div class="content-value">{{ info.emergencyPersonCount }}</div>
            <div class="content-unit">人</div>
          </div>
        </div>
      </div>
    </div>
    <div class="EmergencyOverview-row">
      <div class="EmergencyOverview-row__column">
        <img src="~@src/common/assets/images/screen/disposalTime.png" />
        <div class="column-info">
          <div class="column-info__title">平均处置时长</div>
          <div class="column-info__content">
            <div class="content-value">{{ info.emergencyProcessTime }}</div>
            <div class="content-unit">min</div>
          </div>
        </div>
      </div>
      <div class="EmergencyOverview-row__column">
        <img src="~@src/common/assets/images/screen/responseTime.png" />
        <div class="column-info">
          <div class="column-info__title">平均响应时间</div>
          <div class="column-info__content">
            <div class="content-value">{{ info.emergencyResponseTime }}</div>
            <div class="content-unit">min</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import cacheKeys from "@/common/config/cacheKeys";
export default {
  name: "EmergencyOverview",
  data() {
    return {
      info: {
        emergencyCount: 0,
        emergencyPersonCount: 0,
        emergencyProcessTime: 0,
        emergencyResponseTime: 0
      }
    }
  },
  mounted() {
    this.$fetch(api.emergency.statEmergencyTotal).then(res => {
      if (res.success) {
        this.info = res.returnObj
      }
    })
  },
  methods: {
    addMenuFromLeftNav(menu) {
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    },
    chartClick(menuCode) {
      let menu = {}
      this.$fetch(api.checkMenuPath, {
        "menuCode": menuCode
      }).then((res) => {
        if (res.success) {
          if (res.returnObj != null) {
            menu = {
              code: res.returnObj.menuCode,
              name: res.returnObj.menuName,
              path: res.returnObj.path,
              activePath: res.returnObj.path
            }
            this.addMenuFromLeftNav(menu)
            this.$router.push(menu.path)
          } else {
            this.$message.warning("无此功能权限，请联系管理员");
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.EmergencyOverview {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .EmergencyOverview-row {
    flex: 1;
    height: 0;
    display: flex;

    &__column {
      display: flex;
      align-items: center;
      flex: 1;
      width: 0;

      .column-info {
        display: flex;
        flex-direction: column;
        font-family: SourceHanSans-Medium;
        margin-left: 10px;
        color: rgba(255, 255, 255, 0.8);

        &__title {
          font-size: 20px;
          line-height: 28px;
          // color: rgba(255, 255, 255, 0.8);
        }

        &__content {
          display: flex;

          .content-value {
            font-size: 28px;
            line-height: 36px;
            // color: rgba(255, 255, 255, 0.9);
          }

          .content-unit {
            font-size: 16px;
            // color: rgba(255, 255, 255, 0.8);
            margin-top: 16px;
            margin-left: 5px;
          }
        }
      }
    }
  }
}

.emergency-people {
  cursor: pointer;
}

.emergency-people .column-info:hover {
  color: #409EFF;
}
</style>
